import { createElement } from "react";
import { cva } from "cva";
import { twMerge } from "tailwind-merge";

const styles = cva([], {
  variants: {
    color: {
      black: ["text-dark-gray"],
      white: ["text-white"],
      pink: ["text-pink"],
      primary: ["text-light-purple"],
      secondary: ["text-subtext-gray"],
      darkPurple: ["text-dark-purple"],
      error: ["text-error-red"],
      warning: ["text-warning-yellow"],
      description: ["text-description-text-gray"],
      subheading: ["text-border-dark-gray"],
      transparent: ["text-transparent"],
      inherit: ["text-inherit"],
      lightGreyOnGreyBg: ["text-border-dark-gray"],
    },
    weight: {
      light: ["font-light"],
      normal: ["font-normal"],
      medium: ["font-medium"],
      semibold: ["font-semibold"],
      bold: ["font-bold"],
      extrabold: ["font-extrabold"],
    },
    align: {
      left: ["text-left"],
      center: ["text-center"],
      right: ["text-right"],
    },
    size: {
      vsm: ["text-xs leading-3"],
      sm: ["text-sm leading-4"],
      md: ["text-base leading-5"],
      lg: ["text-lg leading-6"],
      xl: ["text-xl leading-6"],
      "2xl": ["text-2xl leading-7"],
      "4xl": ["text-4xl leading-8"],
    },
    letterSpacing: {
      normal: ["tracking-normal"],
      tight: ["tracking-tight"],
    },
  },
  defaultVariants: {
    color: "black",
    weight: "normal",
    align: "left",
    size: "sm",
    letterSpacing: "normal",
  },
});

const Text = ({
  className,
  children,
  color,
  weight,
  align,
  size,
  as: component = "p",
  ...props
}) => {
  return createElement(
    component,
    {
      className: twMerge(styles({ color, size, align, weight }), className),
      ...props,
    },
    children
  );
};

export default Text;
